module.exports = __webpack_public_path__ + "static/img/智能报账3copy.d90c55c3.png";